export default {
    search: {
        fail: {
            main: 'No result',
            sub: 'Please try another search query'
        }
    },
    counter: 'You have selected 1 person | You have selected {count} persons.'
}
